// Register of all events
// Global events uses the format(Global keyword underscore event name) e.g. [Global_EventName]
// Component events uses the format(component name underscore event name) e.g. [ComponentName_EventName]
export const AdvancedLocalePicker_addAllLocales = 'AdvancedLocalePicker_addAllLocales';